// Note, we're using this with RTK Query / createApi, which auto-prefixes endpoints with /api.
export const UPLOAD_PROJECT_SUBMISSION_ROUTE = '/project_submissions/upload.json';
export const MAX_FILE_SIZE_MB = 40;
// MIME types for file uploads
export const MIME_TYPE_PDF = 'application/pdf';
export const MIME_TYPE_XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

// ZIP MIME type constants
// Standard MIME type for ZIP files (MacOS/Linux)
export const MIME_TYPE_ZIP_STANDARD = 'application/zip';
// Windows browsers may report this non-standard MIME type
export const MIME_TYPE_ZIP_WINDOWS = 'application/x-zip-compressed';
// Combined for validation (accepts both standard and Windows MIME types)
export const MIME_TYPE_ZIP = `${MIME_TYPE_ZIP_STANDARD},${MIME_TYPE_ZIP_WINDOWS}`;

// File extension constants
export const FILE_EXTENSION_PDF = '.pdf';
export const FILE_EXTENSION_XLSX = '.xlsx';
export const FILE_EXTENSION_ZIP = '.zip';
export const GROUP_PROJECT_COLLABORATION_TYPE_OPTIONS = [
    {
        label: 'submission_form.collaboration_type_individual_radio_label',
        value: 'individually',
    },
    {
        label: 'submission_form.collaboration_type_group_radio_label',
        value: 'group',
    },
];
